export default "__VITE_ASSET__KMDKy3yj__"